"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchResultGTMFilter = void 0;
const React = require("react");
const react_instantsearch_1 = require("react-instantsearch");
const app_1 = require("app");
const constants_1 = require("../../constants");
function getGTMFilterValue(lastUserAction) {
    if (lastUserAction.key.includes('Segment')) {
        return constants_1.GTM_SEGMENT_CODE_MAP[lastUserAction.value] || lastUserAction.value;
    }
    if (lastUserAction.type === app_1.FilterTypeEnum.HierarchySelect) {
        return lastUserAction.value.split(' > ').slice(-1)[0];
    }
    return lastUserAction.value;
}
const useSearchResultGTMFilter = (lastUserAction, gtmPageName) => {
    const { results, status } = (0, react_instantsearch_1.useInstantSearch)();
    React.useEffect(() => {
        if (lastUserAction.name !== app_1.LastUserActionNameEnum.Filter || status !== 'idle') {
            return;
        }
        const filterValue = getGTMFilterValue(lastUserAction);
        app_1.GTM.filter({
            numberOfResults: results === null || results === void 0 ? void 0 : results.nbHits,
            pageName: gtmPageName,
            filterCategory: lastUserAction.key,
            filterOptions: filterValue,
        });
    }, [results, lastUserAction, status, gtmPageName]);
};
exports.useSearchResultGTMFilter = useSearchResultGTMFilter;
